import {
  ADD_NEW_BANK,
  DELETE_BANK,
  FETCH_ALL_BANK,
  FETCH_ONE_BANK,
} from "../actions/constants";

const bank = (state = { banks: [], bank: {} }, action) => {
  switch (action.type) {
    case FETCH_ALL_BANK:
      return {
        ...state,
        banks: action.payload,
      };

    case FETCH_ONE_BANK:
      return { ...state, bank: action.payload };

    case ADD_NEW_BANK:
      return { ...state, banks: [...state.banks, action.payload] };

    case DELETE_BANK:
      return {
        ...state,
        banks: state.banks.filter((b) => b._id !== action.payload),
      };
    default:
      return state;
  }
};

export default bank;
